import { useSelectedStores } from "@/config/context/SelectedItemsContext";
import { Select } from "antd";
import { useTranslation } from "react-i18next";

interface OptionType {
  name: string;
  code: string;
  store_id: number;
}

interface StoreFilterProps {
  stores: OptionType[];
  style?: React.CSSProperties;
  width?: number;
  /**
   * Selección única (el Panel de control, xcons-docs#309): un solo store a la vez, sobre el mismo
   * context compartido. Las grillas siguen multi-select.
   */
  single?: boolean;
}

export const StoreFilter: React.FC<StoreFilterProps> = ({
  stores,
  style,
  width = 260,
  single = false,
}) => {
  const { selectedStores, addStore, removeStore, clearStores } =
    useSelectedStores();
  const { t } = useTranslation();

  const handleChange = (selectedValues: string[]) => {
    const currentCodes = selectedStores.map((store) => store.code);

    selectedValues.forEach((code) => {
      if (!currentCodes.includes(code)) {
        const selectedOption = stores.find((store) => store.code === code);
        if (selectedOption) {
          addStore({
            code: selectedOption.code,
            name: selectedOption.name,
            seller_id: selectedOption.store_id,
          });
        }
      }
    });

    currentCodes.forEach((code) => {
      if (!selectedValues.includes(code)) {
        const storeToRemove = selectedStores.find(
          (store) => store.code === code,
        );
        if (storeToRemove) {
          removeStore(storeToRemove.seller_id);
        }
      }
    });
  };

  const handleChangeSingle = (code?: string) => {
    clearStores();
    const selectedOption = code ? stores.find((store) => store.code === code) : undefined;
    if (selectedOption) {
      addStore({
        code: selectedOption.code,
        name: selectedOption.name,
        seller_id: selectedOption.store_id,
      });
    }
  };

  if (single) {
    return (
      <Select
        style={{ width, ...style }}
        allowClear
        placeholder={t("filter.select.placeholder")}
        value={selectedStores?.[0]?.code}
        onChange={handleChangeSingle}
        options={stores?.map((option) => ({
          label: option.name,
          value: option.code,
        }))}
      />
    );
  }

  return (
    <Select
      mode="multiple"
      style={{ width, ...style }}
      allowClear
      placeholder={t("filter.calendar.all")}
      value={selectedStores?.map((store) => store.code)}
      onChange={handleChange}
      options={stores?.map((option) => ({
        label: option.name,
        value: option.code,
      }))}
    />
  );
};
